import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import { PrimaryButton, IconCheckmarkFilled, H3 } from '../../components';

import css from './FreeCustomSubscription.module.css';

const freePlanOptions = [
  'Hair Index Account',
  'Basic Profile Listing (Name, Bio, Types of Offerings)',
  'Moderate Visibility on the Profile Search',
  'Hidden Calendar Listings',
  'Direct Payment Link: Receive payments through a personal link to share directly with your audience.',
  'Basic analytics and reporting',
  'Sales Transaction: 6% platform fee on all sales',
];

const FreeCustomSubscription = ({
  handleCancelSubscription,
  subscriptionId,
  cancelPlanInProgress,
  cancelSubscriptionAtPeriodEnd,
}) => {
  const freePlanSelected = !subscriptionId || cancelSubscriptionAtPeriodEnd;

  return (
    <div className={classNames(css.root, { [css.planSelected]: freePlanSelected })}>
      <H3 as="h3" className={css.title}>
        <FormattedMessage id="BenefitsPage.freeSubscriptionPlanTitle" />
      </H3>

      <H3 as="h4" className={css.btnLabel}>
        <FormattedMessage id="BenefitsPage.btnLabel" />
      </H3>

      <PrimaryButton
        className={css.btn}
        onClick={handleCancelSubscription}
        inProgress={cancelPlanInProgress}
        disabled={!subscriptionId}
      >
        <FormattedMessage id="BenefitsPage.btn" />
      </PrimaryButton>

      <div>
        <p className={css.subscriptionListLabel}>
          <FormattedMessage id="BenefitsPage.freeBenefitsIncludes" />
        </p>
        <ul>
          {freePlanOptions.map(opt => (
            <li key={opt} className={css.option}>
              <IconCheckmarkFilled /> <span className={css.subscriptionOption}>{opt}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FreeCustomSubscription;
